import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import Navbar from "../components/Navbar"
import Navbar1 from "../components/Navbar1"
import Modal from "../components/Modal"

import { useAuth } from "../context/AuthContext"

function Home() {
  const [showModal, setShowModal] = useState(false)
  const { currentUser, room } = useAuth()
  const navigate = useNavigate()

  return (
    <>
      <Navbar />
      <figure className=" h-screen flex ">
        <div className="h-full max-w-4xl m-auto bg-white rounded-lg  py-10 px-1">
          <blockquote className="text-2xl font-medium text-center">
            <p className="text-lg font-semibold">
              Welcome to Aries Online Clinic
            </p>
          </blockquote>
          <blockquote className="text-2xl font-medium text-center">
            A Place To Consult Doctors Online
          </blockquote>
          <div className="bg-white dark:bg-gray-800 ">
            <div className="text-center w-full mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 z-20">
              <h2 className="text-3xl font-extrabold text-black dark:text-white sm:text-4xl">
                {currentUser ? (
                  <>
                    <span className="block">
                      Click on Ask Question to Talk to Dr MD Mazumdar
                    </span>
                    <span className="block text-indigo-500">
                      Click on Your Questions to check your previous questions
                    </span>
                  </>
                ) : (
                  <>
                    <span className="block">
                      You need a account to consult our doctors
                    </span>
                    <span className="block text-indigo-500">
                      Please Sign Up or Login
                    </span>
                  </>
                )}
              </h2>
              <div className="flex items-center justify-center mt-4">
                {currentUser ? (
                  <>
                    <button
                      className="border-2 border-blue-500 rounded-full font-bold text-blue-500 px-4 py-3 transition duration-300 ease-in-out hover:bg-blue-500 hover:text-white mr-6"
                      onClick={() => setShowModal(true)}
                    >
                      Ask A Question
                    </button>
                    <button
                      className="border-2 border-blue-500 rounded-full font-bold text-blue-500 px-4 py-3 transition duration-300 ease-in-out hover:bg-blue-500 hover:text-white mr-6"
                      onClick={() => navigate("/questions")}
                    >
                      Your Questions
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="border-2 border-blue-500 rounded-full font-bold text-blue-500 px-4 py-3 transition duration-300 ease-in-out hover:bg-blue-500 hover:text-white mr-6"
                      onClick={() => navigate("/signup")}
                    >
                      Signup
                    </button>
                    <button
                      className="border-2 border-blue-500 rounded-full font-bold text-blue-500 px-4 py-3 transition duration-300 ease-in-out hover:bg-blue-500 hover:text-white mr-6"
                      onClick={() => navigate("/signin")}
                    >
                      Login
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </figure>
      {showModal && <Modal showModal={showModal} setShowModal={setShowModal} />}
    </>
  )
}

export default Home
